import { IsTileMetricsProvider } from "../tiles.interfaces";
export function IsDrawableTileMapLayer(b) {
    if (b === null || typeof b !== "object")
        return false;
    return b.drawFn !== undefined;
}
export function IsTileMapLayer(b) {
    if (b === null || typeof b !== "object")
        return false;
    return IsTileMetricsProvider(b) && b.provider !== undefined && b.addTo !== undefined;
}
export function IsTileMapLayerProxy(b) {
    if (b === null || typeof b !== "object")
        return false;
    return b.layer !== undefined;
}
export function IsTileMapLayerContainerProxy(b) {
    if (b === null || typeof b !== "object")
        return false;
    return b.layers !== undefined;
}
export function IsPhysicalDisplay(b) {
    if (b === null || typeof b !== "object")
        return false;
    return b.resolution !== undefined && b.dimension !== undefined && b.pixelPerUnit !== undefined;
}
//# sourceMappingURL=tiles.map.interfaces.js.map